export const allCities = [
  "Запоріжжя",
  "Дніпро",
  "Харків",
  "Полтава",
  "Черкаси",
  "Київ",
  "Житомир",
  "Рівне",
  "Луцьк",
  "Крива",
  "Чернівці",
  "Мамаївці",
  "Дубівці",
  "Снятин",
  "Заболотів",
  "Шешори",
  "Коломия",
  "Лісний Хлібичин",
  "Отинія",
  "Франківськ",
  "Івано-Франківськ",
  "Галич",
  "Рогатин",
  "Калуш",
  "Креховичі",
  "Долина",
  "Стрий",
  "Львів",
  "Львів АС2",
  "Львів ж/д",
  "Перемишль",
  "Жешув",
  "Краків",
  "Катовіце",
  "Глівіце",
  "Ченстохова",
  "Ополє",
  "Вроцлав",
  "Єленя Гура",
  "Легніца",
  "Згожелець",
  "Любін",
  "Зелена Гура",
  "Люблін",
  "Варшава",
  "Лодзь",
  "Познань",
  "Гожув Велькопольський",
  "Щецин",
  "Бидгощ",
  "Ліберець",
  "Острава",
  "Оломоуц",
  "Брно",
  "Градець-Кралове",
  "Млада Болеслав",
  "Прага",
  "Рокицани",
  "Плзень",
  "Слубіце",
  "Удіне",
  "Падуя",
  "Болонья",
  "Флоренція",
  "Рим",
  "Неаполь",
  "Салерно",
];

export const mainCities = [
  "Запоріжжя",
  "Дніпро",
  "Харків",
  "Полтава",
  "Черкаси",
  "Київ",
  "Житомир",
  "Рівне",
  "Луцьк",
  "Чернівці",
  "Снятин",
  "Коломия",
  "Франківськ",
  "Івано-Франківськ",
  "Рогатин",
  "Калуш",
  "Долина",
  "Стрий",
  "Львів",
  "Львів АС2",
  "Львів ж/д",
  "Перемишль",
  "Жешув",
  "Краків",
  "Катовіце",
  "Глівіце",
  "Ченстохова",
  "Ополє",
  "Вроцлав",
  "Єленя Гура",
  "Легніца",
  "Згожелець",
  "Любін",
  "Зелена Гура",
  "Люблін",
  "Варшава",
  "Лодзь",
  "Познань",
  "Гожув Велькопольський",
  "Щецин",
  "Бидгощ",
  "Ліберець",
  "Острава",
  "Оломоуц",
  "Брно",
  "Градець-Кралове",
  "Млада Болеслав",
  "Прага",
  "Рокицани",
  "Плзень",
  "Слубіце",
  "Удіне",
  "Падуя",
  "Болонья",
  "Флоренція",
  "Рим",
  "Неаполь",
  "Салерно",
]

export const months = [
  "Cічень",
  "Лютий",
  "Березень",
  "Квітень",
  "Травень",
  "Червень",
  "Липень",
  "Серпень",
  "Вересень",
  "Жовтень",
  "Листопад",
  "Грудень",
]

export const LINE_IDs = [
  '001',
  '002',
  '003',
  '004',
  '005',
  '006',
  '007',
  '008',
]

export const BUS_BRANDS = [
  'EOS',
  'MERCEDES',
  'NEOPLAN',
  'SETRA',
  'VAN',
  'VDL',
  'VOLVO',
]



// WEBPACK FOOTER //
// ./src/constants/arrays.js